module.exports = __webpack_public_path__ + "img/431-0e8524.png";